import {
  createStylesParams,
  StyleParamType,
  wixColorParam,
  wixFontParam,
} from '@wix/tpa-settings';

export type FulfillmentPickerStylesParams = {
  fulfillmentPickerDefaultFont: StyleParamType.Font;
  fulfillmentPickerDefaultTextColor: StyleParamType.Color;
  fulfillmentPickerDefaultBackgroundColor: StyleParamType.Color;
  fulfillmentPickerDefaultBorderColor: StyleParamType.Color;
  fulfillmentPickerDefaultBorderWidth: StyleParamType.Number;
  fulfillmentPickerDefaultCornerRadiusTopLeft: StyleParamType.Number;
  fulfillmentPickerDefaultCornerRadiusTopRight: StyleParamType.Number;
  fulfillmentPickerDefaultCornerRadiusBottomLeft: StyleParamType.Number;
  fulfillmentPickerDefaultCornerRadiusBottomRight: StyleParamType.Number;
  fulfillmentPickerDefaultCornerRadiusLinked: StyleParamType.Number;

  fulfillmentPickerSelectedFont: StyleParamType.Font;
  fulfillmentPickerSelectedTextColor: StyleParamType.Color;
  fulfillmentPickerSelectedBackgroundColor: StyleParamType.Color;
  fulfillmentPickerSelectedBorderColor: StyleParamType.Color;
  fulfillmentPickerSelectedBorderWidth: StyleParamType.Number;
  fulfillmentPickerSelectedCornerRadiusTopLeft: StyleParamType.Number;
  fulfillmentPickerSelectedCornerRadiusTopRight: StyleParamType.Number;
  fulfillmentPickerSelectedCornerRadiusBottomLeft: StyleParamType.Number;
  fulfillmentPickerSelectedCornerRadiusBottomRight: StyleParamType.Number;
  fulfillmentPickerSelectedCornerRadiusLinked: StyleParamType.Number;
};

export const fulfillmentPickerStylesParams =
  createStylesParams<FulfillmentPickerStylesParams>({
    fulfillmentPickerDefaultFont: {
      type: StyleParamType.Font,
      getDefaultValue: (params) =>
        wixFontParam('Body-M', {
          htmlTag: 'p',
          size: params.isMobile ? 14 : 16,
        })(params),
    },
    fulfillmentPickerDefaultTextColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
    fulfillmentPickerDefaultBackgroundColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-1', 1),
    },
    fulfillmentPickerDefaultBorderColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
    fulfillmentPickerDefaultBorderWidth: {
      type: StyleParamType.Number,
      getDefaultValue: () => 1,
    },
    fulfillmentPickerDefaultCornerRadiusTopLeft: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    fulfillmentPickerDefaultCornerRadiusTopRight: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    fulfillmentPickerDefaultCornerRadiusBottomLeft: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    fulfillmentPickerDefaultCornerRadiusBottomRight: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    fulfillmentPickerDefaultCornerRadiusLinked: {
      type: StyleParamType.Number,
      getDefaultValue: () => 1,
    },

    fulfillmentPickerSelectedFont: {
      type: StyleParamType.Font,
      getDefaultValue: (params) =>
        wixFontParam('Body-M', {
          htmlTag: 'p',
          size: params.isMobile ? 14 : 16,
        })(params),
    },
    fulfillmentPickerSelectedTextColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-8', 1),
    },
    fulfillmentPickerSelectedBackgroundColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-8', 0.1),
    },
    fulfillmentPickerSelectedBorderColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-8', 1),
    },
    fulfillmentPickerSelectedBorderWidth: {
      type: StyleParamType.Number,
      getDefaultValue: () => 1,
    },
    fulfillmentPickerSelectedCornerRadiusTopLeft: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    fulfillmentPickerSelectedCornerRadiusTopRight: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    fulfillmentPickerSelectedCornerRadiusBottomLeft: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    fulfillmentPickerSelectedCornerRadiusBottomRight: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    fulfillmentPickerSelectedCornerRadiusLinked: {
      type: StyleParamType.Number,
      getDefaultValue: () => 1,
    },
  });
